function isValidDateRange(
  fromDate: Date,
  toDate: Date,
  maxRange: number
): boolean {

    const maxRangeDate = new Date(fromDate);
    maxRangeDate.setMonth(fromDate.getMonth() + maxRange);

    return toDate <= maxRangeDate;  
}

export default {
  isValidDateRange,
};
